import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  overflow: hidden;
  border-radius: 12px;
  position: relative;
  height: 450px;
  width: 150px;
  display: none;
  flex-shrink: 0;

  @media (min-width: 768px) {
    display: block;
  }
`;

const AdImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

interface VerticalAdProps {
  imageUrl: string;
}

export const VerticalAd: React.FC<VerticalAdProps> = ({ imageUrl }) => (
  <Wrapper>
    <AdImage src={imageUrl} alt="Реклама" />
  </Wrapper>
);
